<script setup>

	const url = useRequestURL()

	const { data: page } = await useAPIFetch('Career')

	useHead({
		bodyAttrs: {
			class: 'no-logo'
		}
	})

	useHeadData({
		title: page.value.meta.title,
		description: page.value.meta.description,
		author: page.value.meta.author,
		copyright: page.value.meta.copyright,
		keywords: page.value.meta.keywords,
		og: page.value.meta.og,
		url: url.href
	})

</script>


<template>
	<div class="container mt-10">
		<div class="grid grid-cols-2">
			<div class="col-span-2 xl:col-span-1">
				<h1 class="text-red mb-8 h2">{{ page.attrs.title }}</h1>
				
				<WysiwygPerexSmall class="mb-8 xl:mb-10" :value="page.attrs.perex" />
				
				<div v-for="component in page.body" :key="component.id">
					<!-- cta -->
					<div v-if="component.component === 'Menu'" class="mb-10 xl:mb-20">
						<div v-for="(item, index) in component.items" :key="index">
							<div v-if="item.component === 'MailtoLink'">
								<Button :to="item.href" target>{{ item.label }}</Button>
							</div>
						</div>
					</div>
					<div v-else-if="component.component === 'ContactList'" class="mb-10 xl:mb-32">
						<div v-for="(item, index) in component.items" :key="index">
							<Contact
								:name="item.person.attrs.name"
								:surname="item.person.attrs.surname"
								:email="item.person.attrs.email"
								:phone="item.person.attrs.phone"
								:image="item.person.attrs.image"
								:title="item.person.attrs.title"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>